import { render, staticRenderFns } from "./DeviceLimitNotice.vue?vue&type=template&id=c6ba1756&"
import script from "./DeviceLimitNotice.vue?vue&type=script&lang=js&"
export * from "./DeviceLimitNotice.vue?vue&type=script&lang=js&"
import style0 from "./DeviceLimitNotice.vue?vue&type=style&index=0&id=c6ba1756&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports